<!-- *ngIf="isShown" -->
<div class="card payment-cards card-with-no-padding">
  <div class="card-head pr-0">
    <div class="row w-100 padding-left align-items-center">
      <div class="col-10 pl-1">
        <div class="title font-24 fontSemiBold">{{'content.Payment Methods' | translate}}</div>
      </div>
      <div class="col-2 text-right pl-auto pr-0" *ngIf="details?.canEdit">
        <button type="button" class="btn btn-with-icon-transparent" [routerLink]="['/admin/settings/payment']"
          [queryParams]="{id: restaurantId}">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>

  </div>

  <div *ngIf='dataLoading' class="dataLoading">
    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
  </div>

  <ng-container *ngIf='!dataLoading'>
    <div class="flex-container d-flex mt-2" *ngIf="details.paymentMethodsProfileList?.length else dataEmpty">
      <ng-container *ngFor="let item of details.paymentMethodsProfileList">
        <div class="card">
          <div class="row">
            <div class="col-12" [innerHTML]="item.icon! | sanitizeHtml">
            </div>
            <div class="col-12">
              <p class="font-16 fontMedium mt-2">{{item.name}}</p>
            </div>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="flex-container bordered d-flex mt-4 mb-0">
      <div class="block">
        <div class="row">
          <div class="col-12">
            <p class="font-16 fontRegular grey-color">{{'content2.Currency' | translate}}</p>
          </div>
          <div class="col-12">
            <p class="font-16 fontMedium mt-2">{{defaultCurrency?.name}}</p>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="row">
          <div class="col-12">
            <p class="font-16 fontRegular grey-color">{{'content2.Deposit Fee' | translate}}</p>
          </div>
          <div class="col-12">
            <p class="font-16 fontMedium mt-2" *ngIf="details.depositFees else empty">
              {{details.depositFees}}
              <span class="grey-color fontRegular">{{defaultCurrency?.currencyCode}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="row">
          <div class="col-12">
            <p class="font-16 fontRegular grey-color">{{'content2.Service' | translate}}</p>
          </div>
          <div class="col-12">
            <p class="font-16 fontMedium mt-2">
              {{details.serviceAmount}}
              <span class="grey-color fontRegular">{{details.serviceAmountType == 'Defult_Currency' ? defaultCurrency?.currencyCode : '%'}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="block">
        <div class="row">
          <div class="col-12">
            <p class="font-16 fontRegular grey-color">
              {{('content2.' + (details.dininPriceIncludeTax ? 'Dinein price includes Tax' : 'Dinein price excludes Tax')) | translate}}
            </p>
          </div>
          <div class="col-12 mt-2">
            <p class="font-16 fontRegular grey-color">
              {{('content2.' + (details.takeawayPriceIncludeTax ? 'Takeaway price includes Tax' : 'Takeaway price excludes Tax')) | translate}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #dataEmpty>
    <empty-state [title]='"content4.No payment methods added yet" | translate'
      [img]="'/assets/images/icons/payment_methods_illustration.svg'"></empty-state>
  </ng-template>

  <ng-template #empty>
    <p class="font-16 fontMedium mt-2">-</p>
  </ng-template>

</div>
